const legalFieldPageStyle = {
  centeredText: {
    textAlign: "center",
    marginTop: "2rem",
  },
  image: {
    display: "block",
    width: "100%",
    height: "auto",
    margin: "0 auto",
  },
};

export default legalFieldPageStyle;
